export default {
  creat: '创建任务',
  business: '任务设计',
  baseinfo: '详细信息',
  qcprice: '设置报价',
  sample: '填写样例',
  tutorial: '教程',
  note1: '模板不满意？',
  note2: '我要定制专属服务！',
  goback: '上一步',
  submit: '保存',
  next: '下一步',
  js: {
    success: '成功',
    successNote: '提交成功',
    error: '失败'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/public/pushTask.js